import api from "@/common/api.js";

export default {
  namespaced: true,

  state: {
    items: null,
    itemsTemp: null,
    itemsFiltro: null,
    itemsFiltroArmazem: null,
    itemsFiltroReaberta: null,
    projetos: null,
    pneus: null,
    pneusEstoque: null,
    placaPreventiva: null
  },

  getters: {
    items: state => state.items,
    itemsTemp: state => state.itemsTemp,
    itemsFiltro: state => state.itemsFiltro,
    itemsFiltroArmazem: state => state.itemsFiltroArmazem,
    itemsFiltroReaberta: state => state.itemsFiltroReaberta,
    projetos: state => state.projetos,
    pneus: state => state.pneus,
    pneusEstoque: state => state.pneusEstoque,
    getPlacaPreventiva: state => state.placaPreventiva
  },

  actions: {
    async fetchPlacaPreventiva({ commit }, { data }){
      try {
        commit('setPlacaPreventiva', 'Carregando')

        const response = await api.post('fetchPlacaPreventiva', { ...data })

        commit('setPlacaPreventiva', response.data[0])
        return response
      } catch (error){
        throw new Error(error)
      }
    },

    async getPneusVeiculo({ commit }, { data }) {
      try {
        const response = await api.post('getPneusVeiculo', { ...data })

        commit('setPneusVeiculo', response.data.pneus)
        commit('setPneusEstoque', response.data.pneusEstoque)
        return response
      } catch (error){
        throw new Error(error)
      }
    },

    setPlacasFromProjeto({ commit }, { nr_seq_projeto }) {
      try {
        commit("setPlacas", nr_seq_projeto);
        // return response
      } catch (error) {
        throw new Error(error);
      }
    },
    async getPlacaFromProjeto({ commit }, { nr_seq_projeto }) {
      try {
        const response = await api.get(`veiculos_projeto/${nr_seq_projeto}`);

        commit("setItems", response.data.items);
        return response;
      } catch (error) {
        throw new Error(error);
      }
    },

    async fetchFromApi({ commit }) {
      try {
        const response = await api.get("veiculos");

        commit("setItems", response.data.items);
        commit("setItemsTemp", response.data.items);
        return response;
      } catch (error) {
        throw new Error(error);
      }
    },
    async fetchFromApiFiltro({ commit }) {
      try {
        const response = await api.get("veiculosFiltro");

        commit("setItemsFiltro", response.data.items);
        return response;
      } catch (error) {
        throw new Error(error);
      }
    },
    async fetchFromApiFiltroArmazem({ commit }) {
      try {
        const response = await api.get("veiculosFiltroArmazem");

        commit("setItemsFiltroArmazem", response.data.items);
        return response;
      } catch (error) {
        throw new Error(error);
      }
    },
    async fetchFromApiFiltroReaberta({ commit }) {
      try {
        const response = await api.get("veiculosFiltroReaberta");

        commit("setItemsFiltroReaberta", response.data.items);
        return response;
      } catch (error) {
        throw new Error(error);
      }
    },
    async fetchFromApiProjetos({ commit }) {
      try {
        const response = await api.get("veiculosProjetos");

        commit("setItemsProjetos", response.data);
        return response;
      } catch (error) {
        throw new Error(error);
      }
    }
  },

  mutations: {
    setPlacaPreventiva(state, placa){
      state.placaPreventiva = placa
    },
    setPneusVeiculo(state, pneus) {
      state.pneus = pneus
    },
    setPneusEstoque(state, pneusEstoque) {
      state.pneusEstoque = pneusEstoque
    },
    setItems(state, items) {
      state.items = items;
    },
    setItemsTemp(state, itemsTemp) {
      state.itemsTemp = itemsTemp;
    },
    setItemsFiltro(state, itemsFiltro) {
      state.itemsFiltro = itemsFiltro;
    },
    setItemsFiltroArmazem(state, itemsFiltroArmazem) {
      state.itemsFiltroArmazem = itemsFiltroArmazem;
    },
    setItemsFiltroReaberta(state, itemsFiltroReaberta) {
      state.itemsFiltroReaberta = itemsFiltroReaberta;
    },
    setItemsProjetos(state, projetos) {
      state.projetos = projetos;
    },
    setPlacasOrigin(state) {
      state.itemsTemp = state.items
    },
    setPlacas(state, projeto) {
      const items = state.items;

      let placas = [];


      items.forEach(element => {
        // console.log(element.veiculo_filial[0].operacao.length)
        // console.log(element.veiculo_filial[0].operacao[0].nr_sequencial)
        if(element.veiculo_filial[0].operacao.length > 0) {
          if (element.veiculo_filial[0].operacao[0].nr_sequencial == projeto) {
            placas.push(element);
          }
        }      
      });

      state.itemsTemp = placas;
    }
  }
};
